import apiClient from '@/plugins/apiClientDrive'
import moment from 'moment';
import countries from "@/plugins/countries.json"


function splitPhoneNumber(phoneNumber) {

    let phone = {};

    countries.forEach(element => {
        if(phoneNumber.includes(element.prefix)){
            phone = {
                prefix: element.prefix,
                country: element.country,
                iso: element.iso,
                phone: phoneNumber.replace(element.prefix,'')
            }
            return true;
        }
    });


    return phone

}


export default {
     namespaced: true,
     state:{
        authenticated: localStorage.getItem('authenticated'),
        token: localStorage.getItem('token'),
        account: (localStorage.getItem('account')) ? JSON.parse(localStorage.getItem('account')) : null,
        errors: {},
        message: null,
        success: null,
     },
     getters:{
        isAuthenticated: state => (state.authenticated) ? true : false,
        account: state => state.account,
        errors: state => state.errors,
        message: state => state.message,
        success: state => state.success,
     },
     actions:{
        login({commit},data){
            return new Promise((resolve, reject) => {
                apiClient.post("auth/token", data).then(resp => {
                        commit('setToken', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        refresh({commit}){

                return new Promise((resolve, reject) => {
                    let data = {
                        "refreshToken": localStorage.getItem('refreshToken')
                    }
                    apiClient.post("auth/refresh-token", data).then(resp => {
                            commit('setToken', resp.data);
                            resolve(resp);
                        })
                        .catch(err => {
                            commit('error', err);
                            commit('logout');
                            reject(err);
                        });
                })
            
        },
        signup({commit},data){
            return new Promise((resolve, reject) => {
                apiClient.post("users", data).then(resp => {
                        commit('account', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        getAccount({commit}){
            return new Promise((resolve, reject) => {
                apiClient.get("users/me").then(resp => {
                        commit('account', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        updateAccount({commit}, data){
            return new Promise((resolve, reject) => {
                apiClient.patch("users/me", data).then(resp => {
                        commit('account', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        updatePassword({commit}, data){
            return new Promise((resolve, reject) => {
                apiClient.put("users/me/password", data).then(resp => {
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        resetPassword({commit}, data){
            return new Promise((resolve, reject) => {
                apiClient.put("users/password", data).then(resp => {
                        commit('forgotPassword',resp)
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        deleteAccount({commit}){
            return new Promise((resolve, reject) => {
                apiClient.delete("users/me").then(resp => {
                        commit('logout')
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        newContact({commit}, data){
            return new Promise((resolve, reject) => {
                apiClient.post("crm/leads", data).then(resp => {
                        commit('newcontact', resp)
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        forceLogout({commit}) {
            commit('logout')
        },
        resetErrors({commit}){
            commit('reset')
        }
     },
     mutations:{
        error(state, err) {
            if(err.response.data.message){
                state.message = err.response.data.message;
                state.errors = err.response.data.errors;
            }else{
                state.message = err.message;
                state.errors = err.statusText;
            }
            state.success = false;
            
        },
        reset(state){
            state.errors = {}
            state.message = null
            state.success = null
        },
        setToken(state, token) {
            localStorage.setItem('token', token.accessToken)
            
            let expirationDate =  moment().add( parseInt(token.expiresIn), 's').format();
            localStorage.setItem('expires_at', expirationDate);

            localStorage.setItem('refreshToken', token.refreshToken)
            localStorage.setItem('authenticated', 'true')
            state.authenticated = true
            state.token = token.accessToken
            state.errors = {}
            state.message = null
        },
        account(state, data){

            let phone = splitPhoneNumber(data.phone)
            data.phone = phone.phone;
            data.phone_prefix = phone.prefix;

            localStorage.setItem('account', JSON.stringify(data))
            state.account = data
            state.errors = {}
            state.message = null
        },
        newcontact(state, resp){
            state.success = true
            state.message = "commons.newcontact-success-message"
        },
        success(state,resp) {

            localStorage.setItem('token', resp.access_token)
            localStorage.setItem('locale', resp.language)
            localStorage.setItem('timezone', resp.timezone)
            localStorage.setItem('authenticated', true)
            state.errors = {}
            state.message = null
            state.authenticated = true
        },
        logout(state) {
            state.errors = {}
            state.message = null
            
            state.authenticated = false;
            state.token = null;
            state.account = null;
            
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('authenticated')
            localStorage.removeItem('account')
            localStorage.removeItem('expires_at')
        },
        forgotPassword(state, resp){
            state.success = true;
            state.message = "commons.forgot-password-reset-success"
            state.errors = {}
        },
        resetPassword(state, resp){
            state.errors = {}
            state.success = true;
            state.message = resp.message
        }
     }
}